export const currencyCodes = [
  'ALL',
  'AFN',
  'ARS',
  'AWG',
  'AUD',
  'AZN',
  'BSD',
  'BBD',
  'BYN',
  'BZD',
  'BMD',
  'BOB',
  'BAM',
  'BWP',
  'BGN',
  'BRL',
  'BND',
  'KHR',
  'CAD',
  'KYD',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'HRK',
  'CUP',
  'CZK',
  'DKK',
  'DOP',
  'XCD',
  'EGP',
  'SVC',
  'EUR',
  'FKP',
  'FJD',
  'GHS',
  'GIP',
  'GTQ',
  'GGP',
  'GYD',
  'HNL',
  'HKD',
  'HUF',
  'ISK',
  'INR',
  'IDR',
  'IRR',
  'IMP',
  'ILS',
  'JMD',
  'JPY',
  'JEP',
  'KZT',
  'KPW',
  'KRW',
  'KGS',
  'LAK',
  'LBP',
  'LRD',
  'MKD',
  'MYR',
  'MUR',
  'MXN',
  'MNT',
  'MZN',
  'NAD',
  'NPR',
  'ANG',
  'NZD',
  'NIO',
  'GNF',
  'NGN',
  'NOK',
  'OMR',
  'PKR',
  'PAB',
  'PYG',
  'PEN',
  'PHP',
  'PLN',
  'QAR',
  'RON',
  'RUB',
  'SHP',
  'SAR',
  'RSD',
  'SCR',
  'SGD',
  'SBD',
  'SOS',
  'ZAR',
  'LKR',
  'SEK',
  'CHF',
  'SRD',
  'SYP',
  'TWD',
  'THB',
  'TTD',
  'TRY',
  'TVD',
  'UAH',
  'GBP',
  'USD',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'YER',
  'ZWD',
] as const;

type CurrencyCode = (typeof currencyCodes)[number];

const isCurrencyCode = (name: string): name is CurrencyCode => (currencyCodes as readonly string[]).includes(name);

interface CurrencyDescription {
  label: string;
  symbol: string;
}

export const takeCurrency = (name: string) => {
  return isCurrencyCode(name) ? CURRENCIES[name] : undefined;
};

export const CURRENCIES: Readonly<Record<CurrencyCode, CurrencyDescription>> = {
  ALL: {
    label: 'Albania Lek',
    symbol: 'Lek',
  },
  AFN: {
    label: 'Afghanistan Afghani',
    symbol: '؋',
  },
  ARS: {
    label: 'Argentina Peso',
    symbol: '$',
  },
  AWG: {
    label: 'Aruba Guilder',
    symbol: 'ƒ',
  },
  AUD: {
    label: 'Australia Dollar',
    symbol: '$',
  },
  AZN: {
    label: 'Azerbaijan Manat',
    symbol: '₼',
  },
  BSD: {
    label: 'Bahamas Dollar',
    symbol: '$',
  },
  BBD: {
    label: 'Barbados Dollar',
    symbol: '$',
  },
  BYN: {
    label: 'Belarus Ruble',
    symbol: 'Br',
  },
  BZD: {
    label: 'Belize Dollar',
    symbol: 'BZ$',
  },
  BMD: {
    label: 'Bermuda Dollar',
    symbol: '$',
  },
  BOB: {
    label: 'Bolivia Bolíviano',
    symbol: '$b',
  },
  BAM: {
    label: 'Bosnia and Herzegovina Convertible Mark',
    symbol: 'KM',
  },
  BWP: {
    label: 'Botswana Pula',
    symbol: 'P',
  },
  BGN: {
    label: 'Bulgaria Lev',
    symbol: 'лв',
  },
  BRL: {
    label: 'Brazil Real',
    symbol: 'R$',
  },
  BND: {
    label: 'Brunei Darussalam Dollar',
    symbol: '$',
  },
  KHR: {
    label: 'Cambodia Riel',
    symbol: '៛',
  },
  CAD: {
    label: 'Canada Dollar',
    symbol: '$',
  },
  KYD: {
    label: 'Cayman Islands Dollar',
    symbol: '$',
  },
  CLP: {
    label: 'Chile Peso',
    symbol: '$',
  },
  CNY: {
    label: 'China Yuan Renminbi',
    symbol: '¥',
  },
  COP: {
    label: 'Colombia Peso',
    symbol: '$',
  },
  CRC: {
    label: 'Costa Rica Colon',
    symbol: '₡',
  },
  HRK: {
    label: 'Croatia Kuna',
    symbol: 'kn',
  },
  CUP: {
    label: 'Cuba Peso',
    symbol: '₱',
  },
  CZK: {
    label: 'Czech Republic Koruna',
    symbol: 'Kč',
  },
  DKK: {
    label: 'Denmark Krone',
    symbol: 'kr',
  },
  DOP: {
    label: 'Dominican Republic Peso',
    symbol: 'RD$',
  },
  XCD: {
    label: 'East Caribbean Dollar',
    symbol: '$',
  },
  EGP: {
    label: 'Egypt Pound',
    symbol: '£',
  },
  SVC: {
    label: 'El Salvador Colon',
    symbol: '$',
  },
  EUR: {
    label: 'Euro',
    symbol: '€',
  },
  FKP: {
    label: 'Falkland Islands (Malvinas) Pound',
    symbol: '£',
  },
  FJD: {
    label: 'Fiji Dollar',
    symbol: '$',
  },
  GHS: {
    label: 'Ghana Cedi',
    symbol: '¢',
  },
  GIP: {
    label: 'Gibraltar Pound',
    symbol: '£',
  },
  GTQ: {
    label: 'Guatemala Quetzal',
    symbol: 'Q',
  },
  GGP: {
    label: 'Guernsey Pound',
    symbol: '£',
  },
  GYD: {
    label: 'Guyana Dollar',
    symbol: '$',
  },
  HNL: {
    label: 'Honduras Lempira',
    symbol: 'L',
  },
  HKD: {
    label: 'Hong Kong Dollar',
    symbol: '$',
  },
  HUF: {
    label: 'Hungary Forint',
    symbol: 'Ft',
  },
  ISK: {
    label: 'Iceland Krona',
    symbol: 'kr',
  },
  INR: {
    label: 'India Rupee',
    symbol: '',
  },
  IDR: {
    label: 'Indonesia Rupiah',
    symbol: 'Rp',
  },
  IRR: {
    label: 'Iran Rial',
    symbol: '﷼',
  },
  IMP: {
    label: 'Isle of Man Pound',
    symbol: '£',
  },
  ILS: {
    label: 'Israel Shekel',
    symbol: '₪',
  },
  JMD: {
    label: 'Jamaica Dollar',
    symbol: 'J$',
  },
  JPY: {
    label: 'Japan Yen',
    symbol: '¥',
  },
  JEP: {
    label: 'Jersey Pound',
    symbol: '£',
  },
  KZT: {
    label: 'Kazakhstan Tenge',
    symbol: 'лв',
  },
  KPW: {
    label: 'Korea (North) Won',
    symbol: '₩',
  },
  KRW: {
    label: 'Korea (South) Won',
    symbol: '₩',
  },
  KGS: {
    label: 'Kyrgyzstan Som',
    symbol: 'лв',
  },
  LAK: {
    label: 'Laos Kip',
    symbol: '₭',
  },
  LBP: {
    label: 'Lebanon Pound',
    symbol: '£',
  },
  LRD: {
    label: 'Liberia Dollar',
    symbol: '$',
  },
  MKD: {
    label: 'Macedonia Denar',
    symbol: 'ден',
  },
  MYR: {
    label: 'Malaysia Ringgit',
    symbol: 'RM',
  },
  MUR: {
    label: 'Mauritius Rupee',
    symbol: '₨',
  },
  MXN: {
    label: 'Mexico Peso',
    symbol: '$',
  },
  MNT: {
    label: 'Mongolia Tughrik',
    symbol: '₮',
  },
  MZN: {
    label: 'Mozambique Metical',
    symbol: 'MT',
  },
  NAD: {
    label: 'Namibia Dollar',
    symbol: '$',
  },
  NPR: {
    label: 'Nepal Rupee',
    symbol: '₨',
  },
  ANG: {
    label: 'Netherlands Antilles Guilder',
    symbol: 'ƒ',
  },
  NZD: {
    label: 'New Zealand Dollar',
    symbol: '$',
  },
  NIO: {
    label: 'Nicaragua Cordoba',
    symbol: 'C$',
  },
  GNF: {
    label: 'Guinean franc',
    symbol: 'FG',
  },
  NGN: {
    label: 'Nigeria Naira',
    symbol: '₦',
  },
  NOK: {
    label: 'Norway Krone',
    symbol: 'kr',
  },
  OMR: {
    label: 'Oman Rial',
    symbol: '﷼',
  },
  PKR: {
    label: 'Pakistan Rupee',
    symbol: '₨',
  },
  PAB: {
    label: 'Panama Balboa',
    symbol: 'B/.',
  },
  PYG: {
    label: 'Paraguay Guarani',
    symbol: 'Gs',
  },
  PEN: {
    label: 'Peru Sol',
    symbol: 'S/.',
  },
  PHP: {
    label: 'Philippines Peso',
    symbol: '₱',
  },
  PLN: {
    label: 'Poland Zloty',
    symbol: 'zł',
  },
  QAR: {
    label: 'Qatar Riyal',
    symbol: '﷼',
  },
  RON: {
    label: 'Romania Leu',
    symbol: 'lei',
  },
  RUB: {
    label: 'Russia Ruble',
    symbol: '₽',
  },
  SHP: {
    label: 'Saint Helena Pound',
    symbol: '£',
  },
  SAR: {
    label: 'Saudi Arabia Riyal',
    symbol: '﷼',
  },
  RSD: {
    label: 'Serbia Dinar',
    symbol: 'Дин.',
  },
  SCR: {
    label: 'Seychelles Rupee',
    symbol: '₨',
  },
  SGD: {
    label: 'Singapore Dollar',
    symbol: '$',
  },
  SBD: {
    label: 'Solomon Islands Dollar',
    symbol: '$',
  },
  SOS: {
    label: 'Somalia Shilling',
    symbol: 'S',
  },
  ZAR: {
    label: 'South Africa Rand',
    symbol: 'R',
  },
  LKR: {
    label: 'Sri Lanka Rupee',
    symbol: '₨',
  },
  SEK: {
    label: 'Sweden Krona',
    symbol: 'kr',
  },
  CHF: {
    label: 'Switzerland Franc',
    symbol: 'CHF',
  },
  SRD: {
    label: 'Suriname Dollar',
    symbol: '$',
  },
  SYP: {
    label: 'Syria Pound',
    symbol: '£',
  },
  TWD: {
    label: 'Taiwan New Dollar',
    symbol: 'NT$',
  },
  THB: {
    label: 'Thailand Baht',
    symbol: '฿',
  },
  TTD: {
    label: 'Trinidad and Tobago Dollar',
    symbol: 'TT$',
  },
  TRY: {
    label: 'Turkey Lira',
    symbol: '',
  },
  TVD: {
    label: 'Tuvalu Dollar',
    symbol: '$',
  },
  UAH: {
    label: 'Ukraine Hryvnia',
    symbol: '₴',
  },
  GBP: {
    label: 'United Kingdom Pound',
    symbol: '£',
  },
  USD: {
    label: 'United States Dollar',
    symbol: '$',
  },
  UYU: {
    label: 'Uruguay Peso',
    symbol: '$U',
  },
  UZS: {
    label: 'Uzbekistan Som',
    symbol: 'лв',
  },
  VEF: {
    label: 'Venezuela Bolívar',
    symbol: 'Bs',
  },
  VND: {
    label: 'Viet Nam Dong',
    symbol: '₫',
  },
  YER: {
    label: 'Yemen Rial',
    symbol: '﷼',
  },
  ZWD: {
    label: 'Zimbabwe Dollar',
    symbol: 'Z$',
  },
} as const;

export const isCurrencyWidespread = (code: string | null | undefined): boolean => {
  if (!code) return false;

  return ['USD', 'EUR', 'GBP', 'JPY'].includes(code);
};
